import React from "react";

export function AdditionalInfoDetermination({application,creditInformation}){
    console.log("Application",application)
    return (
        <div className="row justify-content-center text-center px-5">
            <h5>Additional information has been requested to {application.companyName}.</h5>
        </div>
    )
}